
import Header from '@/components/jobBooking/Header/Header.vue';
import Button from '../../components/UI/button/Button.vue';
import { Component, Vue } from 'vue-property-decorator';
import { getNews } from '@/api';
import { notificationErrorText } from '@/utils/PortalConstants';
import { mapState } from 'vuex';
import { User } from '@/models/main';

import { formatDateStringWithTZ } from '@/utils/InputProcessingUtilities';

interface newsEntry {
  id: number;
  author: string;
  title: string;
  content: string;
  image: string;
  type: string;
  updated_at: Date;
  created_at: Date;
}

@Component({
  components: {
    Button,
    Header,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class HomePage extends Vue {
  // LOADERS
  private loading = false;

  private user!: User;
  private formatDateStringWithTZ = formatDateStringWithTZ;

  private carouselImgs = [
    require('@/assets/images/DJI_0012_1300_400.jpg'),
    require('@/assets/images/DSC_9746_1300_400.jpg'),
    require('@/assets/images/AKP_2983_1300_400.jpg'),
    require('@/assets/images/DSC_9687_1300_400.jpg'),
    require('@/assets/images/AKP_7229_1300_400.jpg'),
  ];

  //News related
  private limit = 2;
  private serviceUpdatesLimit = 2;
  private newsEntries: newsEntry[] = [];
  private loadNews() {
    this.loading = true;
    getNews()
      .then(res => {
        this.newsEntries = res.data;
        this.loading = false;
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Error loading News data',
          text: notificationErrorText,
          type: 'warn',
        });
      });
  }
  get newsLimited(): newsEntry[] {
    const whatsNew = this.newsEntries.filter(item => item.type !== 'service');
    return this.limit ? whatsNew.slice(0, this.limit) : whatsNew;
  }
  get serviceUpdates(): newsEntry[] {
    const serviceUpdatesNews = this.newsEntries.filter(item => item.type === 'service');
    return this.limit ? serviceUpdatesNews.slice(0, this.limit) : serviceUpdatesNews;
  }

  private mounted() {
    this.loadNews();
  }
}
